import React, { useState } from "react";

import { Modal } from "reactstrap";
import { toast } from "react-toastify";

import "assets/css/home-modern.css";
import "assets/css/flow.css";

// core components
import DefaultFooter from "components/Footers/DefaultFooter.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FlowHero from "components/Flow/FlowHero";
import OrderLines from "components/Flow/OrderLines";
import { useBusySpan } from "hooks/useBusy";
import { APIRequest, errorHandlerNew } from "utils/ApiRequest";
import { DO_NOT_CLOSE } from "utils/busyStore";
import { formatINR } from "utils/format";
import { useNavigate } from "react-router";

import heroImage from "assets/img/banner0.jpg";
import bankQr from "assets/img/sbi_qr.jpeg";
import bankLogo from "assets/img/axis.png";

const FLOW_STEPS = ["Select passes", "Review & pay"];

function OrderDPSummary() {
  const [token, setToken] = useState(null);
  const history = useNavigate();
  const [cartRes, setCartRes] = useState(null);
  const [modalLarge, setModalLarge] = React.useState(false);
  const [offlineTxnId, setOfflineTxnId] = useState(null);
  const [offlineBankName, setOfflineBankName] = useState(null);
  const [orderRcptId, setOrderRcptId] = useState(null);
  const [orderTotal, setOrderTotal] = useState(null);
  const setBusy = useBusySpan(DO_NOT_CLOSE);

  React.useEffect(() => {
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo !== null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session !== null) {
        setToken(userInfo.session);
        loadCartData(userInfo.session);
      } else {
        history("/login")
      }
    } else {
      history("/login")
    }

    return function cleanup() {
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const failWith = (err) => {
    setBusy(null);
    errorHandlerNew(err);
  };

  function loadCartData(token) {
    APIRequest(
      token,
      "/getCartDetails",
      {},
      (res) => {
        if (res.data === null || res.data.length === 0) history("/dmPass");
        setCartRes(res.data);
      },
    );
  }

  const handleOnlineOrderNow = (e) => {
    e.preventDefault();
    setBusy("Opening the secure payment window…");
    APIRequest(
      token,
      "/startOrder",
      {
        offline: false
      },
      (res) => {
        loadRazorPay(res.data);
        deleteCart();
      },
      failWith
    );
  }

  const handleOfflineOrderNow = (e) => {
    e.preventDefault();
    setBusy("Fetching the transfer details…");
    APIRequest(
      token,
      "/startOrder",
      {
        offline: true
      },
      (res) => {
        loadOfflinePay(res.data);
        deleteCart();
      },
      failWith
    );
  }

  const handleOfflineUpdDetails = (e) => {
    e.preventDefault();
    if (offlineTxnId === undefined || offlineTxnId === null || offlineTxnId === "") {
      toast.error("Please add the Bank/UPI transaction id to proceed");
      return;
    }
    setBusy("Recording your transaction…");
    APIRequest(
      token,
      "/handleOfflineOrder",
      { isOffline: true, offlineTxnId, offlineBankName, orderRcptId },
      (res) => {
        localStorage.removeItem('selectedPrds');
        localStorage.removeItem('totalCartPrice');
        let userInfo = localStorage.getItem('user-info');
        if (userInfo != null) {
          userInfo = JSON.parse(userInfo);
          userInfo.member = true;
          localStorage.setItem('user-info', JSON.stringify(userInfo));
        }
        setBusy(null);
        toast.success('Your contribution deatils are captured and sent for verfication, will sent you an email on once verification completes!');
        history("/profile");
      },
      failWith
    );
  }

  function loadOfflinePay(order) {
    setOrderRcptId(order.orderRcptId);
    setOrderTotal(order.orderTotalInPaisa / 100);
    setBusy(null);
    setModalLarge(true);
  }

  async function deleteCart() {
    APIRequest(
      token,
      "/deleteCart",
      {},
      (res) => {
        localStorage.removeItem('selectedPrds');
        localStorage.removeItem('totalCartPrice');
      },
    );
  }

  const handleStartOver = (e) => {
    localStorage.removeItem('selectedPrds');
    localStorage.removeItem('totalCartPrice');
    history("/dmPass");
  }

  const handleModalClose = () => {
    setModalLarge(false);
    deleteCart();
    localStorage.removeItem('selectedPrds');
    localStorage.removeItem('totalCartPrice');
    history("/profile");
  }


  async function loadRazorPay(order) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        const options = {
          key: 'rzp_live_7n7vOYR9yX50XZ',
          currency: order.currency,
          amount: order.orderTotalInPaisa,
          order_id: order.orderOrTokenId,
          name: 'Membership Contibution',
          description: 'Contribution for SORRBA Membership',
          image: 'https://app.sorrba.org/static/media/now-logo.9315a628.png',
          handler: function (response) {
            setBusy("Confirming your contribution…");
            APIRequest(
              token,
              "/handleSuccessOrder",
              { isOffline: false, orderId: response.razorpay_order_id, razorpayPaymentId: response.razorpay_payment_id, razorpaySignature: response.razorpay_signature },
              (res) => {
                localStorage.removeItem('selectedPrds');
                localStorage.removeItem('totalCartPrice');
                let userInfo = localStorage.getItem('user-info');
                if (userInfo != null) {
                  userInfo = JSON.parse(userInfo);
                  userInfo.member = true;
                  localStorage.setItem('user-info', JSON.stringify(userInfo));
                }
                setBusy(null);
                toast.success('Congratulations!! We received your contibution, Please check you email for datails!');
                history("/profile");
              },
              failWith
            );
          },
          modal: {
            "ondismiss": function () {
              setBusy(null);
              toast.error('Payment failed, order couldn\'t be processed successfully!');
              history("/dmPass");
            }
          },
          prefill: {
            name: order.userFullName,
            email: order.userEmail,
            contact: order.userMobile
          }
        }
        const paymentObject = new window.Razorpay(options);
        paymentObject.on('payment.failed', function (response) {
          setBusy("Recording the failed attempt…");
          APIRequest(
            token,
            "/handleFailOrder",
            { orderId: response.error.metadata.order_id, razorpayPaymentId: response.error.metadata.payment_id },
            (res) => {
              localStorage.removeItem('selectedPrds');
              localStorage.removeItem('totalCartPrice');
              setBusy(null);
              toast.error('Payment failed, order couldn\'t be processed successfully!');
              history("/dmPass");
            },
            failWith
          );
        });
        paymentObject.open();
        setBusy(null);
      };
      script.onerror = () => {
        setBusy(null);
        toast.error('Seems some internal issue with your network, please check your network!');
      }
      document.body.appendChild(script);
    });
  }

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <FlowHero
          image={heroImage}
          eyebrow={"Step 2 of " + FLOW_STEPS.length}
          title="Review & pay"
          lead="One last look at your passes and offerings before you pay."
          steps={FLOW_STEPS}
          activeStep={1}
        />
        <div className="main hm hm-flow">
          <section className="hm-fbody">
            <div className="hm-wrap">
              {cartRes === null && (
                <div className="hm-fstate">
                  <span className="hm-spinner" aria-hidden="true"></span>
                  <p style={{ margin: 0 }}>Loading your cart…</p>
                </div>
              )}

              {cartRes !== null && (
                <div className="hm-checkout-solo">
                  <div className="hm-panel">
                    <div className="hm-panel-head">
                      <h2>Your order</h2>
                      <p>
                        {cartRes.selectedProducts != null ? cartRes.selectedProducts.length : 0}{" "}
                        {cartRes.selectedProducts != null && cartRes.selectedProducts.length === 1
                          ? "item"
                          : "items"}{" "}
                        ready to pay
                      </p>
                    </div>
                    <OrderLines cart={cartRes} />
                    <div className="hm-payopts">
                      <div className="hm-payopt">
                        <button
                          className="hm-btn hm-btn-primary"
                          type="button"
                          onClick={(e) => { handleOnlineOrderNow(e) }}
                        >
                          Pay &#x20B9;{formatINR(cartRes.totalSellPrice)} now
                        </button>
                        <small>Card, UPI or netbanking · secured by Razorpay</small>
                      </div>
                    </div>
                    <p className="hm-payback">
                      <button type="button" onClick={(e) => { handleStartOver(e) }}>
                        Back to passes
                      </button>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
        <DefaultFooter />
      </div>

      <Modal isOpen={modalLarge} size="lg" centered scrollable contentClassName="hm-modal">
        <div className="hm-modal-head">
          <div>
            <span className="hm-modal-eyebrow">Direct transfer</span>
            <h5 className="hm-modal-title">Pay and share the details</h5>
          </div>
          <button
            aria-label="Close"
            className="hm-modal-x"
            type="button"
            onClick={() => handleModalClose()}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="hm-modal-body">
          <div className="hm-amount-due">
            <span>Amount to transfer</span>
            <b>&#x20B9;{formatINR(orderTotal)}</b>
          </div>
          <div className="hm-paygrid">
            <div className="hm-qr">
              <span className="hm-qr-l">Scan to pay</span>
              <img alt="Payment QR code" src={bankQr} />
            </div>
            <div className="hm-bank">
              <img className="hm-bank-logo" alt="Axis Bank" src={bankLogo} />
              <dl>
                <div>
                  <dt>Account payee</dt>
                  <dd>Sarjapur Outer Ring Road Bengali Association</dd>
                </div>
                <div>
                  <dt>Account number</dt>
                  <dd className="is-num">912010038909637</dd>
                </div>
                <div>
                  <dt>IFSC code</dt>
                  <dd className="is-num">UTIB0002145</dd>
                </div>
              </dl>
            </div>
          </div>
          <div className="hm-fform" style={{ marginTop: "1.3rem" }}>
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="dps-txn">Bank / UPI transaction ID *</label>
              <div className="hm-fld-wrap">
                <input
                  id="dps-txn"
                  className="hm-fld-i"
                  type="text"
                  placeholder="e.g. 402912345678"
                  onChange={(e) => setOfflineTxnId(e.target.value)}
                />
              </div>
            </div>
            <div className="hm-fld">
              <label className="hm-fld-l" htmlFor="dps-bank">Bank name</label>
              <div className="hm-fld-wrap">
                <input
                  id="dps-bank"
                  className="hm-fld-i"
                  type="text"
                  placeholder="e.g. HDFC Bank"
                  onChange={(e) => setOfflineBankName(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="hm-modal-foot">
          <button className="hm-btn hm-btn-primary" type="button" onClick={(e) => { handleOfflineUpdDetails(e) }}>
            Update payment details
          </button>
        </div>
      </Modal>

    </>
  );
}

export default OrderDPSummary;
